import cookie from 'js-cookie'
import GLOBAL_VARIABLE from '../../constants/global-variable.enum'

const NEXON_HOMEPAGE = 'nxsignin'

function getMetaByAttr(key) {
  const el = document.querySelector(`meta[type="inface"][platform="jppc"]`)

  if (!el) return
  return el.getAttribute(key)
}

class PlatformJPPC {
  constructor({ npp, gm }) {
    this.type = 'jppc'
    this._npp = npp
    this.gm = getMetaByAttr('gm') || gm || NEXON_HOMEPAGE // meta tag 가 최우선
    this.authLibUrl = 'https://platform.nexon.co.jp/Auth/js/npf_auth_c.js'
  }

  get npp() {
    return this._npp ? decodeURIComponent(this._npp) : this._npp
  }

  set npp(value) {
    this._npp = value
  }

  getAuthorization() {
    if (this.npp) {
      return `Jppc ${this.npp}`
    }
  }

  getWebTokenBody() {
    return { npp: this.npp }
  }

  getVerifyWebTokenBody() {
    this.updateSession()
    return { npp: this.npp }
  }

  updateSession() {
    const value = cookie && cookie.get('NPP')
    if (value) {
      this.npp = value
    }
  }

  clear() {
    const clearTargets = ['NPP']
    clearTargets.forEach((cookieKey) => {
      cookie.remove(cookieKey, { domain: GLOBAL_VARIABLE.WEB_TOKEN_DOMAIN })
      cookie.remove(cookieKey)
    })

    this.npp = null
  }
  
  /**
   * NPP 값을 검증합니다.
   * @returns {Boolean}
   */
  isValidSession() {
    this.updateSession()

    if (!this.npp) {
      return false
    }
    
    return this.npp.indexOf('NP12') > -1 && this.npp.split(':').length > 3
  }
}

export default PlatformJPPC